import React from 'react'

const AuthServiceContext = React.createContext({})

export default AuthServiceContext
